import { withContext } from "Context";
import { OTPubSubWrapper } from "./OTPubSubWrapper";

export default withContext(
  ([{ user }]) => ({
    user
  }),
  OTPubSubWrapper
);
